const services = [
  {
    id: 0,
    service_name: "Бронирование отелей",
    service_image: "/cities/guangzhou.jpg",
    service_description: '«Карлсон Туризм» является партнером таких крупных мировых туроператоров, как "Gulliver’s Travel Associates", "KUONI Travel Ltd.", "TRAVCO Ltd.", "TOURICO Holidays", "Miki Travel Ltd". Особое значение имеет сотрудничество с немецкими операторами "Dertour", "Tui", "Airtours", расширяющее возможности бронирования гарантированных номеров повышенной категории в отелях, виллах и других нестандартных видов размещения по привлекательным ценам даже в самый пик сезона. Мы сможем забронировать для вас более 150 000 отелей по всему миру в режиме онлайн или по нашим прямым контрактам с мировыми отельными цепочками.',
  },
  {
    id: 1,
    service_name: "Визовая поддержка",
    service_image: "/tours/beijing_tour.webp",
    service_description: "Компания предоставляет своим клиентам визовое обслуживание, компания «Карлсон Туризм» аккредитован в большинстве Посольств зарубежных стран, расположенных в Москве.",
  },
  {
    id: 2,
    service_name: "Авиабилеты",
    service_image: "/tours/beijing_tour.webp",
    service_description: "Компания «Карлсон Туризм» может обеспечить бронирование и продажу авиабилетов из Москвы на авиарейсы как по России и СНГ, так и в любую точку мира. Являясь прямым агентом ведущих российских и зарубежных авиакомпаний, благодаря нашей аккредитации в Международной ассоциации воздушного транспорта (IATA), мы предлагаем нашим партнерам клиентам авиабилеты по наиболее выгодным ценам, а современные системы бронирования - Amadeus, Galileo, Sirena, дают возможность доступа практически ко всем авиакомпаниям.",
  },
  {
    id: 3,
    service_name: "Трансферы",
    service_image: "/tours/beijing_tour.webp",
    service_description: "Организация индивидуального или группового трансфера на автомобилях различного класса с водителем получила в последнее время широкое распространение среди наших клиентов.",
  },
  {
    id: 4,
    service_name: "Индивидуальные туры",
    service_image: "/tours/beijing_tour.webp",
    service_description: "Вам не хочется все время находиться рядом с гидом и большой группой? Вы можете обращаться в «Карлсон Туризм» с просьбой подобрать вам тур с индивидуальной программой. Специалисты помогут разработать свой собственный маршрут, с учетом всех особенностей того региона, куда вы направляетесь, а также с учетом ваших персональных пожеланий по деталям поездки.",
  },
];
export default services;
